const exploreLinks = [
  { label: '热门推荐', href: '#hot' },
  { label: '分类浏览', href: '#categories' },
  { label: '人气排行', href: '#ranking' },
  { label: '最新更新', href: '#latest' },
];

const catLinks = [
  '热血冒险',
  '奇幻玄幻',
  '科幻机甲',
  '恋爱甜宠',
  '悬疑推理',
  '搞笑日常',
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg" />
              </span>
              <span className="font-display text-xl font-bold text-background-50">
                嘿休漫画<span className="text-accent-400">网址</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              聚合全站漫画资源，按分类、人气排行、热门推荐整理，作品库持续扩充。想看什么直接翻，找漫画更省时。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['漫画大全', '漫画合集', '漫画分类', '人气排行'].map((t) => (
                <span
                  key={t}
                  className="rounded-full bg-background-800 px-3 py-1 text-xs text-background-200"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-display text-base font-bold text-background-50">快速浏览</h3>
            <ul className="mt-4 space-y-2.5">
              {exploreLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-display text-base font-bold text-background-50">热门分类</h3>
            <ul className="mt-4 flex flex-wrap gap-x-4 gap-y-2.5">
              {catLinks.map((cat) => (
                <li key={cat}>
                  <a
                    href="#categories"
                    className="text-sm text-background-300 transition-colors hover:text-accent-400"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-6 space-y-2 text-sm text-background-300">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line" /> heyxiu_comic@example.com
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-time-line" /> 每日更新 · 持续扩充
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-800 pt-6 text-xs text-background-400 sm:flex-row">
          <p>© {new Date().getFullYear()} 嘿休漫画网址 · 聚合漫画分类、人气排行与热门推荐</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-focus-3-line" /> 作品库持续扩充中，找漫画更省时
          </p>
        </div>
      </div>
    </footer>
  );
}